export default __webpack_public_path__ + "4e738ba.png";